module.exports = __webpack_public_path__ + "static/media/รายงานปิดบัญชี.8b2231d2.xls";